<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Allergies
    </template>
    <allergies-base button-top small fixed :callback="createPatientAllergy" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import AllergiesBase from "@/core/components/health/allergies/AllergiesBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "allergies",
    components: {
        'allergies-base': AllergiesBase
    },
    methods: {
        ...mapActions('health', ['createPatientAllergy']),
    }
})
</script>